<template>
  <!-- SLP口语开发特训营 -->
  <div class="SLP">
    <PublicCert :logo="Logo7" :type="'jy-slp'" :color="'#8760bc'" />
  </div>
</template>

<script>
import PublicCert from '../component/certQuery.vue'
import Logo7 from '@/assets/images/logo7.png'

export default {
  name: 'SLP',
  components: {
    PublicCert
  },
  data() {
    return {
      Logo7
    }
  }
}
</script>